export const ensureUnreadIndicatorStyles = (): void => {
    if (document.getElementById('comments-polling-host-style')) {
        return;
    }

    const style = document.createElement('style');
    style.id = 'comments-polling-host-style';
    style.innerHTML = `
        .position-name-icons .comment-action-icon {
            position: relative;
            display: inline-flex;
        }

        .position-name-icons .comment-action-icon .comments-unread-indicator {
            position: absolute;
            top: 0;
            right: -2px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #EC3030;
            box-shadow: 0 0 0 2px #FFFFFF;
        }
    `;

    document.head.appendChild(style);
};
